module.exports = __webpack_public_path__ + "img/sec7mob.2b6ff6c1.png";